import { useTranslation } from 'react-i18next'
import contentData from '../../data/content.json'

function Footer() {
  const { t } = useTranslation()

  return (
    <footer className="w-full bg-sage py-80 px-20 tablet:px-32">
      <div className="max-w-lg mx-auto">
        {/* Main CTA Section */}
        <div className="flex flex-col items-center text-center">
          <h3 className="font-lato font-normal text-white text-[32px] tablet:text-[40px] mb-12">
            {t('pages.home.sections.contact.heading')}
          </h3>
          <p className="text-lato-italic text-white/90 text-lg tablet:text-xl mb-32">
            {t('pages.home.sections.contact.subheading')}
          </p>

          {/* Contact Form Link */}
          <a
            href={contentData.contactForm.url}
            target={contentData.contactForm.openInNewTab ? '_blank' : '_self'}
            rel="noopener noreferrer"
            className="btn-primary"
          >
            {t('navigation.ctaButton.text')}
          </a>
        </div>

        {/* Divider */}
        <div className="w-24 h-[1px] bg-white/30 mx-auto my-40"></div>

        {/* Copyright */}
        <div className="text-center text-white/60">
          <p className="text-sm">
            © {new Date().getFullYear()} Nuria Arbesú. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
